module.exports = require("./dje.js");